import { LOCALE } from '../../../constants/activity-constants'

const ec = LOCALE === "es-EC"
const arg = LOCALE === "es-AR"

export let textCountry = {}

if (arg) {
  textCountry = {
    text1: 'Si aún no tenés una cuenta y querés participar',
    textLink1: 'Registrate acá'
  }
}else{
  textCountry = {
    text1: 'Si aún no tienes una cuenta y quieres participar',
    textLink1: 'Regístrate aquí'
  }
}